export default "__VITE_ASSET__CU_cPmY8__"